<template>
  <div class="comments-area" :class="cls">    
    
    <div class="add-comment">
      <textarea ref="newcommenttext" v-if="creatingComment" id="" cols="30" rows="3"></textarea>
      <div class="btn" v-if="creatingComment" @click="cancelCreateComment()">Annullér</div>
      <div class="btn" @click="createComment()">Tilføj</div>
    </div>

    <br>

    <div class="comments-list">
      <div class="comment" v-for="(c,c_i) in comments" :key="'c'+c_i">
        
        <avatar :input="c.user"></avatar>
        
        <div class="before">
          
          <div class="name">
            {{c.user.first_name}} {{c.user.last_name}}
          </div>

          <div class="created">
            {{c.created_human2}}
            (
              {{c.created_human}}
              <template v-if="c.edited">
                &mdash; Redigeret
              </template>
            )
          </div>

        </div>
      
        <div class="text" v-html="nl2br(c.text)" v-if="editing_comment_i != c_i"></div>

        <div class="edit-comment" v-if="editing_comment_i == c_i">
          <textarea v-model="editing_comment_text" cols="30" rows="3"></textarea>
          <div class="btn" @click="editing_comment_i = undefined">Annullér</div>
          <div class="btn" @click="saveEditedComment()">Gem</div>
        </div>

        <div class="after" v-if="editing_comment_i != c_i">
          <div class="edit-btn" v-if="c.can_edit" @click="setEditingComment(c,c_i)">Redigér</div>
          <div class="delete-btn" v-if="c.can_delete" @click="archiveComment(c)">Slet</div>
        </div>

      </div>      
    </div>

  </div>
</template>

<script>
import fdb from '.././firebase_config.js';
import mixins from '.././mixins.js';
import moment from 'moment'
import Avatar from '.././components/Avatar'
export default {
  components: { Avatar, },
  mixins: [ mixins.db, mixins.generic ],
  props: {
    keytype: { type:String },
    keyis: { type:String },
    classes: { type:String },
  },
  data(){ return {
    creatingComment: false,
    editing_comment_i: undefined,
    editing_comment_text: undefined,    
  } },
  computed: {
    
    cls(){
      var c = ''      
      if( this.$props.classes ) c += ' '+this.$props.classes+' '
      return c
    },

    comments(){

      var items = this.$store.getters['comments/byKey']( this.keytype, this.keyis )

      for( let item of items ) {
        item.can_edit = item.user_key === this.my_user_key
        item.can_delete = ( this.is_admin || item.user_key === this.my_user_key )
      }

      items = items.sort((a,b)=>{
        return moment(b.created,'YYYY-MM-DD').unix() - moment(a.created,'YYYY-MM-DD').unix()
      })

      return items
    },

    users(){
      return this.$store.state.firebase.users
    },

  },
  methods: {

    nl2br(input){
      var output = input.replace(/(?:\r\n|\r|\n)/g, '<br>')
      return output
    },

    cancelCreateComment(){
      this.$refs.newcommenttext.value = undefined
      this.creatingComment = false
    },

    createComment(){

      if( !this.creatingComment ) {
        this.creatingComment = true
        var _this = this
        setTimeout(()=>{
          _this.$refs.newcommenttext.focus()
        },0)
        return true
      }

      var d = {
        keytype: this.keytype,
        key: this.keyis,
        text: this.$refs.newcommenttext.value,
        user_key: this.my_user['.key'],
        user_uid: this.my_user.uid,
        created: moment().toISOString(),
      }

      fdb.ref('comments').push(d)

      this.creatingComment = false
      this.$refs.newcommenttext.value = undefined
      eventBus.$emit('triggerIconSignal', 'thumbsup')
      
    },

    archiveComment(c) {
      var sure = confirm('Are you sure?')
      if( !sure ) return
      fdb.ref('comments').child(c['.key']).update({ archived:true })
      eventBus.$emit('triggerIconSignal', 'thumbsup')
    },

    setEditingComment(c,c_i) {
      this.editing_comment_i = c_i
      this.editing_comment_text = c.text
      setTimeout(()=>{
        document.querySelector('.edit-comment textarea').focus()
      },0)
    },

    saveEditedComment(){
      var c = this.comments[ this.editing_comment_i ]
      var data = {
        text: this.editing_comment_text,
        edited: true,
      }
      fdb.ref('comments').child(c['.key']).update(data)
      this.editing_comment_i = undefined
      eventBus.$emit('triggerIconSignal', 'thumbsup')
    },

  },
}
</script>



// WEBPACK FOOTER //
// Comments.vue?4414db04